// paquetes
import {useLocation,  useParams, useNavigate, useOutletContext} from 'react-router-dom';
import React, {useState, useEffect, useRef  } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
// componentes
import ZonaCargando from '../../alertas/zonaCargando';
import ServicioPagoReserva from '../../../componentesEspeciales/pagos/servicioPagoReserva';
import ResumenReserva from '../../../componentesEspeciales/reserva/resumenReserva';
import EstadoReserva from '../../../componentesEspeciales/reserva/estadoReserva';
import ChatReserva from '../../../componentesEspeciales/reserva/chatReserva';
// estilos
import '../../../estilos/usuario.css';







function ReservaIndividualComprador(datos) {

    const { usuario, setUsuario, cargandoUsuario, ahoraServidor } = useOutletContext() || {}; // variables que vienen de direccionamiento 
    const navigate                      = useNavigate();
    const location                      = useLocation();
    const { idReserva, idUsuario, quienEs } = location.state || {};
    
    // Variables
    const [cargando, setCargando]  = useState(false);
    const cargandoFinal            = Boolean(cargandoUsuario) || Boolean(cargando);
    
    const [servicio, setServicio]  = useState(null);
    const [reserva, setReserva]    = useState(null);
    const [mensajes, setMensajes]  = useState(null);
    const [contraparte, setContraparte] = useState(null); // { nombre, telefono, pais } — solo si la reserva está pagada y activa
    const [valoraciones, setValoraciones] = useState(null);



    useEffect(() => {
        (async () => {
            if (cargandoUsuario) return; // Espera a que Direccionamiento termine de cargar sesión

            // Si no hay usuario, esta página requiere login
            if (!usuario) { return navigate("/iniciar-sesion"); }

            // Validamos que esta página reciba una reserva enviada por navegación interna
            if (!idReserva) {
                Swal.fire({
                    icon: "error",
                    title: "Reserva no disponible",
                    text: "No fue posible identificar la reserva.",
                    confirmButtonColor: "var(--azul-logo-fondo)"
                });
                return navigate("/usuario/reservas");
            }

            // Cotejamos el usuario enviado por navegación con el usuario logueado
            const idUsuarioLogueado = usuario?.idUsuario;

            if (idUsuario && idUsuarioLogueado && String(idUsuario) !== String(idUsuarioLogueado)) {
                Swal.fire({ icon: "error", title: "Acceso no permitido", text: "Esta reserva no pertenece a tu cuenta.", confirmButtonColor: "var(--azul-logo-fondo)" });
                return navigate("/usuario/reservas");
            }

            if (quienEs && quienEs !== "Comprador") {
                Swal.fire({ icon: "error", title: "Acceso no permitido", text: "No tienes permisos para ver esta reserva desde esta sección.", confirmButtonColor: "var(--azul-logo-fondo)" });
                return navigate("/usuario/reservas");
            }

            try {
                setCargando(true);


                // 1. Buscamos la reserva y servicio en un solo metodo y mensajes
                const resReserva = await axios.post("/obtener-reserva-y-servicio", { 
                params: { idUsuario: usuario.idUsuario, idReserva: idReserva, modo: quienEs  }
                });
                // guadar variables
                setServicio(resReserva.data.servicioActual);
                setReserva(resReserva.data.reservaActual);
                setMensajes(resReserva.data.mensajesActuales);
                setContraparte(resReserva.data.contraparte || null);
                setValoraciones(resReserva.data.valoracionesActuales);
                //console.log("resReserva: ", resReserva);
                // console.log("Reserva comprador recibida:", { idReserva, idUsuario, idUsuarioLogueado, quienEs });
            }
            finally {
                setCargando(false);
            }
        })();
    }, [usuario, cargandoUsuario, idReserva, idUsuario, quienEs, navigate]);
    


    

    



    return(
    <div >
    { (cargandoFinal) ? <ZonaCargando />
    :  usuario ? 
    <div className='d-flex flex-row '>
        {/* Columna 2 */}
        <div className="flex-grow-1 container-fluid contenedorAdaptador ">     
            {/* Contenedor título  */}
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-dark">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        {/* título */}
                        <div>
                            <h1 className="h2 text-dark mb-1">Reserva</h1>
                        </div>
                    </div>
                </div>
            </div>


            {servicio && reserva ? 
            <div className='container'>
                <div className='row g-4 align-items-stretch'>
                    {/* COLUMNA 1: RESUMEN */}
                    <div className='col-12 col-lg-6'>
                        <ResumenReserva reserva={reserva} servicio={servicio} />
                    </div>

                    {/* COLUMNA 2: ESTADO Y CHAT */}
                    <div className='col-12 col-lg-6'>
                        <EstadoReserva reserva={reserva} quienEs={quienEs} usuario={usuario} servicio={servicio} ahoraServidor={ahoraServidor} valoraciones={valoraciones} />
                        <ChatReserva reserva={reserva} usuario={usuario} mensajesTodos={mensajes} quienEs={quienEs} contraparte={contraparte} />
                    </div>
                </div>
            </div>
            : null}
        </div>
    </div>
    : null
    }
    </div>  
    )
}
  
  
  
export default ReservaIndividualComprador;